module.exports = __webpack_public_path__ + "img/ico_rank2-m.5d0fba24.png";